/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import Draggable from 'react-draggable';

import { CompareArrows } from '@material-ui/icons'
import { Typography, Fab, Tooltip } from '@material-ui/core'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class FieldSimilarityAction extends Component {
    state = {
        boundingBox : null
    }

    handleStart = (e) => {
        this.setState({...this.state, boundingBox : e.target.getBoundingClientRect()})
	}

	handleStop = (e) => {
		const { top, left } = e.target.getBoundingClientRect();
		// compare the start position to the current one
		// if no change, assume this is a simple click
		if(top === this.state.boundingBox.top && left === this.state.boundingBox.left){
			this.props.check_field_similarity(this.props.column_indices)
		}
	}

    render() { 
        return (
            <Draggable
                axis = "y"
                bounds = 'parent'
                onStart={this.handleStart}
                onStop={this.handleStop}
            >
                <Fab 
                    style = {{
                        width : '120px',
                        position : 'fixed',
                        top : '330px',
                        left : 'calc('+ (25 * this.props.column_indices[1]) + 'vw - 60px)',
                        backgroundColor : 'rgb(175, 68, 242)',
                        color : '#FFFFFF',
                        fontSize : 13,
                        zIndex : 10
                    }}
                    size = 'small'
                    variant="extended"
                >
                    <CompareArrows fontSize = "small" style = {{marginRight : '5px'}} />
                    Similarity
                </Fab>
            </Draggable>
        );
    }
}
 
export default FieldSimilarityAction;